import { axios } from '@/lib/axios'
import {
  FALLBACK_EXCHANGE_RATE,
  HKD_CURRENCY,
  getExchangeRateToHKD,
  normalizeExchangeRateMap,
} from '@/utils/exchangeRate.util'
import { useQuery } from '@tanstack/react-query'

const EXCHANGE_RATE_ENDPOINT = '/offers/exchange-rates/hkd'

export { FALLBACK_EXCHANGE_RATE, HKD_CURRENCY, getExchangeRateToHKD }

export const getExchangeRateMap = async () => {
  try {
    const exchangeRateResult = await axios.get(EXCHANGE_RATE_ENDPOINT)
    const rates = exchangeRateResult?.data?.data ?? exchangeRateResult?.data
    return normalizeExchangeRateMap(rates)
  } catch (err) {
    return { [HKD_CURRENCY]: 1 }
  }
}
export const useExchangeRate = () => {
  return useQuery({
    queryKey: ['exchange-rate'],
    queryFn: getExchangeRateMap,

    // Cache for 12 hours
    staleTime: 1000 * 60 * 60 * 12,

    // Keep in cache for 24 hours after unused
    gcTime: 1000 * 60 * 60 * 24,

    // Don't refetch just because the user switches tabs
    refetchOnWindowFocus: false,

    // Retry once on failure
    retry: 1,
  })
}
